module.exports = __webpack_public_path__ + "static/media/speaker_ATAL_DAVE_CHAN.08e5dbae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_ATAL_DAVE_CHAN.jpg
// module id = 238
// module chunks = 0